"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PivotAnswerResolver = void 0;
const NodeIdAnswersResolver_1 = require("./NodeIdAnswersResolver");
const application_1 = require("../../types/models/application");
const BlueprintIdAnswersResolver_1 = require("./BlueprintIdAnswersResolver");
// It writes in both answers format, but it can read from either one.
class PivotAnswerResolver {
    answerResolverV1; //{insured-first: {firstname: 'bob'}}}} // v1.usingNodeIds.getAnswer
    answerResolverV2; // {uuid: {uuid {uuid: {uuid: 'bob'}}}} // v2.usingNodeIds.getAnswer
    answersToUse;
    constructor(answerResolverV1, answerResolverV2, answersToUse) {
        this.answerResolverV1 = answerResolverV1;
        this.answerResolverV2 = answerResolverV2;
        this.answersToUse = answersToUse;
    }
    static from(versionedAnswers, nodeIdToAnswerPath, blueprint, answersToUse, logger) {
        const answerResolverV1 = NodeIdAnswersResolver_1.NodeIdAnswersResolver.from(nodeIdToAnswerPath, blueprint, versionedAnswers.v1, logger);
        const answerResolverV2 = BlueprintIdAnswersResolver_1.BlueprintIdAnswersResolver.from(blueprint, versionedAnswers.v2, logger);
        return new PivotAnswerResolver(answerResolverV1, answerResolverV2, answersToUse);
    }
    clone(withAnswers) {
        const clonedAnswerResolverV1 = this.answerResolverV1.clone(withAnswers);
        const clonedAnswerResolverV2 = this.answerResolverV2.clone(withAnswers);
        return new PivotAnswerResolver(clonedAnswerResolverV1, clonedAnswerResolverV2, this.answersToUse);
    }
    export() {
        return new application_1.VersionedAnswers({
            v1: this.answerResolverV1.export().v1,
            v2: this.answerResolverV2.export().v2,
        });
    }
    // @deprecated
    dump() {
        return this.export();
    }
    knowsId(blueprintId) {
        if (this.answersToUse === 'v2') {
            return this.answerResolverV2.knowsId(blueprintId);
        }
        else {
            return this.answerResolverV1.knowsId(blueprintId);
        }
    }
    getAnswer(blueprintId, blueprintIdInstanceIdentifiers) {
        if (this.answersToUse === 'v2') {
            return this.answerResolverV2.getAnswer(blueprintId, blueprintIdInstanceIdentifiers);
        }
        else {
            return this.answerResolverV1.getAnswer(blueprintId, blueprintIdInstanceIdentifiers);
        }
    }
    getCollection(blueprintId, blueprintIdInstanceIdentifiers) {
        if (this.answersToUse === 'v2') {
            return this.answerResolverV2.getCollection(blueprintId, blueprintIdInstanceIdentifiers);
        }
        else {
            return this.answerResolverV1.getCollection(blueprintId, blueprintIdInstanceIdentifiers);
        }
    }
    getRepeatedAnswers(collectionBlueprintId, blueprintIds, blueprintIdInstanceIdentifiers) {
        if (this.answersToUse === 'v2') {
            return this.answerResolverV2.getRepeatedAnswers(collectionBlueprintId, blueprintIds, blueprintIdInstanceIdentifiers);
        }
        else {
            return this.answerResolverV1.getRepeatedAnswers(collectionBlueprintId, blueprintIds, blueprintIdInstanceIdentifiers);
        }
    }
    getRepetitionCount(collectionBlueprintId, blueprintIdInstanceIdentifiers) {
        if (this.answersToUse === 'v2') {
            return this.answerResolverV2.getRepetitionCount(collectionBlueprintId, blueprintIdInstanceIdentifiers);
        }
        else {
            return this.answerResolverV1.getRepetitionCount(collectionBlueprintId, blueprintIdInstanceIdentifiers);
        }
    }
    setAnswer(value, blueprintId, blueprintIdInstanceIdentifiers, answersOverride) {
        this.answerResolverV1.setAnswer(value, blueprintId, blueprintIdInstanceIdentifiers, answersOverride);
        this.answerResolverV2.setAnswer(value, blueprintId, blueprintIdInstanceIdentifiers, answersOverride);
    }
    unsetAnswer(blueprintId, blueprintIdInstanceIdentifiers) {
        const hasRemovedSomethingV2 = this.answerResolverV2.unsetAnswer(blueprintId, blueprintIdInstanceIdentifiers);
        const hasRemovedSomethingV1 = this.answerResolverV1.unsetAnswer(blueprintId, blueprintIdInstanceIdentifiers);
        return hasRemovedSomethingV2 || hasRemovedSomethingV1;
    }
    unsetAnswerSelectOptionId(blueprintId, optionId, blueprintIdInstanceIdentifiers) {
        const hasUnsetSomethingInV2 = this.answerResolverV2.unsetAnswerSelectOptionId(blueprintId, optionId, blueprintIdInstanceIdentifiers);
        const hasUnsetSomethingInV1 = this.answerResolverV1.unsetAnswerSelectOptionId(blueprintId, optionId, blueprintIdInstanceIdentifiers);
        return hasUnsetSomethingInV2 || hasUnsetSomethingInV1;
    }
    withCollectionIdentifier(identifiers, collectionBlueprintId, collectionInstanceIndex) {
        if (this.answersToUse === 'v2') {
            return this.answerResolverV2.withCollectionIdentifier(identifiers, collectionBlueprintId, collectionInstanceIndex);
        }
        else {
            return this.answerResolverV1.withCollectionIdentifier(identifiers, collectionBlueprintId, collectionInstanceIndex);
        }
    }
    removeUndefinedAnswersFromCollection(blueprintId, blueprintIdInstanceIdentifiers) {
        const hasRemovedSomethingV2 = this.answerResolverV2.removeUndefinedAnswersFromCollection(blueprintId, blueprintIdInstanceIdentifiers);
        const hasRemovedSomethingV1 = this.answerResolverV1.removeUndefinedAnswersFromCollection(blueprintId, blueprintIdInstanceIdentifiers);
        return hasRemovedSomethingV2 || hasRemovedSomethingV1;
    }
    getInstanceId(blueprintId, blueprintIdInstanceIdentifiers) {
        if (this.answersToUse === 'v2') {
            return this.answerResolverV2.getInstanceId(blueprintId, blueprintIdInstanceIdentifiers);
        }
        else {
            return this.answerResolverV1.getInstanceId(blueprintId, blueprintIdInstanceIdentifiers);
        }
    }
    setInstanceId(blueprintId, blueprintIdInstanceIdentifiers, forceInstanceId) {
        if (this.answersToUse === 'v2') {
            return this.answerResolverV2
                .setInstanceId(blueprintId, blueprintIdInstanceIdentifiers, forceInstanceId)
                .andThen((surrogateIdReturned) => {
                return this.answerResolverV1.setInstanceId(blueprintId, blueprintIdInstanceIdentifiers, surrogateIdReturned);
            });
        }
        else {
            return this.answerResolverV1
                .setInstanceId(blueprintId, blueprintIdInstanceIdentifiers, forceInstanceId)
                .andThen((surrogateIdReturned) => {
                return this.answerResolverV2.setInstanceId(blueprintId, blueprintIdInstanceIdentifiers, surrogateIdReturned);
            });
        }
    }
    setAnswers(items, blueprintIdInstanceIdentifiers) {
        for (const item of items) {
            this.answerResolverV2.setAnswer(item.value, item.blueprintId, blueprintIdInstanceIdentifiers);
            this.answerResolverV1.setAnswer(item.value, item.blueprintId, blueprintIdInstanceIdentifiers);
        }
    }
    clearAnswers() {
        this.answerResolverV1.clearAnswers();
        this.answerResolverV2.clearAnswers();
    }
    unsetAnswers(nodeInstancesToRemove) {
        const removedNodeInstances = [];
        for (const nodeInstance of nodeInstancesToRemove) {
            const { id, scope } = nodeInstance;
            const wasRemovedV2 = this.answerResolverV2.unsetAnswer(id, scope);
            const wasRemovedV1 = this.answerResolverV1.unsetAnswer(id, scope);
            if (wasRemovedV2 || wasRemovedV1) {
                removedNodeInstances.push(nodeInstance);
            }
        }
        return removedNodeInstances;
    }
    //#region usingNodeId
    knowsIdByNodeId(nodeId) {
        if (this.answersToUse === 'v2') {
            return this.answerResolverV2.usingNodeId().knowsId(nodeId);
        }
        else {
            return this.answerResolverV1.usingNodeId().knowsId(nodeId);
        }
    }
    getAnswerByNodeId(nodeId, nodeIdInstanceIdentifiers) {
        if (this.answersToUse === 'v2') {
            return this.answerResolverV2.usingNodeId().getAnswer(nodeId, nodeIdInstanceIdentifiers);
        }
        else {
            return this.answerResolverV1.usingNodeId().getAnswer(nodeId, nodeIdInstanceIdentifiers);
        }
    }
    getCollectionByNodeId(nodeId, nodeIdInstanceIdentifiers) {
        if (this.answersToUse === 'v2') {
            return this.answerResolverV2.usingNodeId().getCollection(nodeId, nodeIdInstanceIdentifiers);
        }
        else {
            return this.answerResolverV1.usingNodeId().getCollection(nodeId, nodeIdInstanceIdentifiers);
        }
    }
    getRepeatedAnswersByNodeId(collectionNodeId, nodeIds, nodeIdInstanceIdentifiers) {
        if (this.answersToUse === 'v2') {
            return this.answerResolverV2
                .usingNodeId()
                .getRepeatedAnswers(collectionNodeId, nodeIds, nodeIdInstanceIdentifiers);
        }
        else {
            return this.answerResolverV1
                .usingNodeId()
                .getRepeatedAnswers(collectionNodeId, nodeIds, nodeIdInstanceIdentifiers);
        }
    }
    getRepetitionCountByNodeId(collectionNodeId, nodeIdInstanceIdentifiers) {
        if (this.answersToUse === 'v2') {
            return this.answerResolverV2.usingNodeId().getRepetitionCount(collectionNodeId, nodeIdInstanceIdentifiers);
        }
        else {
            return this.answerResolverV1.usingNodeId().getRepetitionCount(collectionNodeId, nodeIdInstanceIdentifiers);
        }
    }
    setAnswerByNodeId(value, nodeId, nodeIdInstanceIdentifiers, answersOverride) {
        this.answerResolverV1.usingNodeId().setAnswer(value, nodeId, nodeIdInstanceIdentifiers, answersOverride);
        this.answerResolverV2.usingNodeId().setAnswer(value, nodeId, nodeIdInstanceIdentifiers, answersOverride);
    }
    unsetAnswerByNodeId(nodeId, nodeIdInstanceIdentifiers) {
        const hasRemovedSomethingV2 = this.answerResolverV2.usingNodeId().unsetAnswer(nodeId, nodeIdInstanceIdentifiers);
        const hasRemovedSomethingV1 = this.answerResolverV1.usingNodeId().unsetAnswer(nodeId, nodeIdInstanceIdentifiers);
        return hasRemovedSomethingV2 || hasRemovedSomethingV1;
    }
    unsetAnswerSelectOptionIdByNodeId(nodeId, optionId, nodeIdInstanceIdentifiers) {
        const hasUnsetSomethingInV2 = this.answerResolverV2
            .usingNodeId()
            .unsetAnswerSelectOptionId(nodeId, optionId, nodeIdInstanceIdentifiers);
        const hasUnsetSomethingInV1 = this.answerResolverV1
            .usingNodeId()
            .unsetAnswerSelectOptionId(nodeId, optionId, nodeIdInstanceIdentifiers);
        return hasUnsetSomethingInV2 || hasUnsetSomethingInV1;
    }
    withCollectionIdentifierByNodeId(identifiers, collectionNodeId, collectionInstanceIndex) {
        if (this.answersToUse === 'v2') {
            return this.answerResolverV2
                .usingNodeId()
                .withCollectionIdentifier(identifiers, collectionNodeId, collectionInstanceIndex);
        }
        else {
            return this.answerResolverV1
                .usingNodeId()
                .withCollectionIdentifier(identifiers, collectionNodeId, collectionInstanceIndex);
        }
    }
    removeUndefinedAnswersFromCollectionByNodeId(nodeId, nodeIdInstanceIdentifiers) {
        const hasRemovedSomethingV2 = this.answerResolverV2
            .usingNodeId()
            .removeUndefinedAnswersFromCollection(nodeId, nodeIdInstanceIdentifiers);
        const hasRemovedSomethingV1 = this.answerResolverV1
            .usingNodeId()
            .removeUndefinedAnswersFromCollection(nodeId, nodeIdInstanceIdentifiers);
        return hasRemovedSomethingV2 || hasRemovedSomethingV1;
    }
    getInstanceIdByNodeId(nodeId, nodeIdInstanceIdentifiers) {
        if (this.answersToUse === 'v2') {
            return this.answerResolverV2.usingNodeId().getInstanceId(nodeId, nodeIdInstanceIdentifiers);
        }
        else {
            return this.answerResolverV1.usingNodeId().getInstanceId(nodeId, nodeIdInstanceIdentifiers);
        }
    }
    setInstanceIdByNodeId(nodeId, nodeIdInstanceIdentifiers, forceInstanceId) {
        if (this.answersToUse === 'v2') {
            return this.answerResolverV2
                .usingNodeId()
                .setInstanceId(nodeId, nodeIdInstanceIdentifiers, forceInstanceId)
                .andThen((surrogateIdReturned) => {
                return this.answerResolverV1
                    .usingNodeId()
                    .setInstanceId(nodeId, nodeIdInstanceIdentifiers, surrogateIdReturned);
            });
        }
        else {
            return this.answerResolverV1
                .usingNodeId()
                .setInstanceId(nodeId, nodeIdInstanceIdentifiers, forceInstanceId)
                .andThen((surrogateIdReturned) => {
                return this.answerResolverV2
                    .usingNodeId()
                    .setInstanceId(nodeId, nodeIdInstanceIdentifiers, surrogateIdReturned);
            });
        }
    }
    setAnswersByNodeId(items, nodeIdInstanceIdentifiers) {
        for (const item of items) {
            this.answerResolverV2.usingNodeId().setAnswer(item.value, item.nodeId, nodeIdInstanceIdentifiers);
            this.answerResolverV1.usingNodeId().setAnswer(item.value, item.nodeId, nodeIdInstanceIdentifiers);
        }
    }
    unsetAnswersByNodeId(nodeInstancesToRemove) {
        const removedNodeInstances = [];
        for (const nodeInstance of nodeInstancesToRemove) {
            const { id: nodeId, scope: nodeIdInstanceIdentifiers } = nodeInstance;
            const wasRemovedV2 = this.answerResolverV2.usingNodeId().unsetAnswer(nodeId, nodeIdInstanceIdentifiers);
            const wasRemovedV1 = this.answerResolverV1.usingNodeId().unsetAnswer(nodeId, nodeIdInstanceIdentifiers);
            if (wasRemovedV2 || wasRemovedV1) {
                removedNodeInstances.push(nodeInstance);
            }
        }
        return removedNodeInstances;
    }
    getBlueprint() {
        return this.answerResolverV2.getBlueprint();
    }
    //#endregion
    usingNodeId() {
        return {
            setAnswers: (...args) => this.setAnswersByNodeId(...args),
            getInstanceId: (...args) => this.getInstanceIdByNodeId(...args),
            setInstanceId: (...args) => this.setInstanceIdByNodeId(...args),
            knowsId: (...args) => this.knowsIdByNodeId(...args),
            getAnswer: (...args) => this.getAnswerByNodeId(...args),
            getCollection: (...args) => this.getCollectionByNodeId(...args),
            getRepeatedAnswers: (...args) => this.getRepeatedAnswersByNodeId(...args),
            getRepetitionCount: (...args) => this.getRepetitionCountByNodeId(...args),
            setAnswer: (...args) => this.setAnswerByNodeId(...args),
            unsetAnswer: (...args) => this.unsetAnswerByNodeId(...args),
            unsetAnswers: (...args) => this.unsetAnswersByNodeId(...args),
            unsetAnswerSelectOptionId: (...args) => this.unsetAnswerSelectOptionIdByNodeId(...args),
            withCollectionIdentifier: (...args) => this.withCollectionIdentifierByNodeId(...args),
            removeUndefinedAnswersFromCollection: (...args) => this.removeUndefinedAnswersFromCollectionByNodeId(...args),
            getBlueprint: (...args) => this.getBlueprint(...args),
        };
    }
}
exports.PivotAnswerResolver = PivotAnswerResolver;
